/** Azure speechTokenResult 内存缓存（STT/TTS 共用，expiresAt 来自 Gateway） */

export interface SpeechTokenEntry {
  token: string
  region: string
  expiresAt: number
}

const REFRESH_BUFFER_SEC = 60

/** 判断缓存是否在 expiresAt 前至少 REFRESH_BUFFER_SEC 仍有效 */
export function isSpeechTokenCacheValid(entry: SpeechTokenEntry | null): boolean {
  if (!entry?.token || !entry.region) {
    return false
  }
  const nowSec = Math.floor(Date.now() / 1000)
  return entry.expiresAt - nowSec > REFRESH_BUFFER_SEC
}

export class SpeechTokenCache {
  private entry: SpeechTokenEntry | null = null

  get(): SpeechTokenEntry | null {
    return isSpeechTokenCacheValid(this.entry) ? this.entry : null
  }

  set(entry: SpeechTokenEntry): void {
    this.entry = entry
  }

  clear(): void {
    this.entry = null
  }
}
